









































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Account } from "@/models/account";
import accountsApi from "@/services/accounts";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Getter, Action } from "vuex-class";
import { Order } from "@/models/order";
import { Package } from "@/models/package";
import ProductIcon from "@/components/ProductIcon.vue";

@Component({
  components: {
    ProductIcon
  }
})
export default class Cart extends Vue {
  @Prop({ required: true }) private item?: Package;

  get canIncDec() {
    return true; // this.item && this.item.category !== "shipping";
  }
}
